// extracted by mini-css-extract-plugin
export var actionIcon = "SquareCard-module--actionIcon--knzFK";
export var body = "SquareCard-module--body--lSLh8";
export var bxTextTruncateEnd = "SquareCard-module--bx--text-truncate--end--AzOpA";
export var bxTextTruncateFront = "SquareCard-module--bx--text-truncate--front--JUYpN";
export var darkMode = "SquareCard-module--darkMode--f8ejR";
export var disabled = "SquareCard-module--disabled--wHfgp";
export var helperIcon = "SquareCard-module--helperIcon--vvRlk";
export var helperText = "SquareCard-module--helperText--sJc43";
export var squareCard = "SquareCard-module--squareCard--h1ZQn";
export var title = "SquareCard-module--title--0mapy";
export var titleSmall = "SquareCard-module--titleSmall--GS3Ul";